/**
 * World Cup 2026 Theme - Constants
 */

window.theme = window.theme || {};

window.theme.routes = {
  cart: '/cart',
  cartAdd: '/cart/add',
  cartChange: '/cart/change',
  cartUpdate: '/cart/update',
  cartClear: '/cart/clear'
};

window.theme.strings = {
  addToCart: 'Add to Cart',
  soldOut: 'Sold Out',
  unavailable: 'Unavailable',
  quantity: 'Quantity',
  addedToCart: 'Added to cart!',
  error: 'Something went wrong. Please try again.',
  cartEmpty: 'Your cart is empty',
  cartUpdated: 'Cart updated',
  itemRemoved: 'Item removed'
};

window.theme.settings = {
  cartType: 'drawer',
  moneyFormat: '${{amount}}',
  ageRestriction: '15+',
  showAgeWarning: true
};